// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Reducer$LiteracyplanetTupperware from "../Reducer.res.mjs";
import * as V3RevealApi$LiteracyplanetTupperware from "./V3RevealApi.res.mjs";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V2ExerciseStateStoreContext$LiteracyplanetTupperware from "../v2/V2ExerciseStateStoreContext.res.mjs";

function findByIdPairRightSide(answerStringArray, responseOptionId) {
  return Belt_List.reduce(answerStringArray, undefined, (function (acc, answer) {
                if (acc !== undefined) {
                  return acc;
                }
                var match = answer.split(Reducer$LiteracyplanetTupperware.splitChar);
                if (match.length !== 2) {
                  return acc;
                }
                var left = match[0];
                var right = match[1];
                if (left === responseOptionId) {
                  return right;
                } else {
                  return acc;
                }
              }));
}

function V3ClozeBucketProvider(props) {
  var questionIndex = props.questionIndex;
  var match = V2ExerciseStateStoreContext$LiteracyplanetTupperware.useDispatch();
  var dispatch = match[1];
  var match$1 = V2ExerciseContext$LiteracyplanetTupperware.use();
  var getStep = match$1.getStep;
  var answerVisible = Curry._1(match$1.isCorrectAnswerVisible, questionIndex);
  var getMarkType = function (id) {
    return Reducer$LiteracyplanetTupperware.getMarkTypeWip(Curry._1(getStep, questionIndex), id);
  };
  var findDroppedId = function (id) {
    return Belt_Option.flatMap(Reducer$LiteracyplanetTupperware.mapIdPair(Curry._1(getStep, questionIndex), (function (dragId, param) {
                      return dragId === id;
                    })), (function (param) {
                  return param[1];
                }));
  };
  var isDropped = function (id) {
    return Belt_Option.isSome(Reducer$LiteracyplanetTupperware.mapIdPair(Curry._1(getStep, questionIndex), (function (param, dropId) {
                      return dropId === id;
                    })));
  };
  var findCorrectResponse = function (id) {
    var match = Curry._1(getStep, questionIndex);
    if (typeof match !== "object") {
      return ;
    }
    if (match.TAG === "Attempted") {
      return ;
    }
    var match$1 = match._0;
    if (typeof match$1 !== "object") {
      return ;
    } else {
      return findByIdPairRightSide(match$1._0.answer, id);
    }
  };
  var onUndoDrop = function (drag, drop) {
    if (Reducer$LiteracyplanetTupperware.isMarked(Curry._1(getStep, questionIndex))) {
      return ;
    } else {
      return Curry._1(dispatch, {
                  TAG: "DeleteResponseIdentifier",
                  _0: questionIndex,
                  _1: {
                    TAG: "IdPair",
                    _0: drag,
                    _1: drop
                  }
                });
    }
  };
  var onDrop = function (drag, drop) {
    if (Reducer$LiteracyplanetTupperware.isMarked(Curry._1(getStep, questionIndex))) {
      return ;
    } else {
      return Curry._1(dispatch, {
                  TAG: "SetQuestionState",
                  _0: questionIndex,
                  _1: {
                    TAG: "SetResponse",
                    _0: {
                      TAG: "BoolResponsePayload",
                      _0: {
                        TAG: "IdPair",
                        _0: drag,
                        _1: drop
                      }
                    }
                  },
                  _2: "ResponseMarking"
                });
    }
  };
  return React.createElement(V3RevealApi$LiteracyplanetTupperware.Provider.make, {
              value: {
                reveal: props.reveal
              },
              children: React.createElement(V3DndBehaviour$LiteracyplanetTupperware.DndProvider.make, {
                    api: {
                      findDroppedId: findDroppedId,
                      isDropped: isDropped,
                      findCorrectResponse: findCorrectResponse,
                      answerVisible: answerVisible,
                      getMarkType: getMarkType,
                      onUndoDrop: onUndoDrop,
                      onDrop: onDrop,
                      overClassName: props.overClassName,
                      dropClassName: props.dropClassName,
                      renderDragComponent: props.renderDragComponent,
                      renderDragOverlayComponent: props.renderDragOverlayComponent,
                      renderAlreadyDraggedPlaceholder: props.renderAlreadyDraggedPlaceholder,
                      renderAlreadyDraggedAndMarkedPlaceholder: props.renderAlreadyDraggedAndMarkedPlaceholder,
                      renderDroppedComponent: props.renderDroppedComponent,
                      renderCorrectDroppedComponent: props.renderCorrectDroppedComponent,
                      renderIncorrectDroppedComponent: props.renderIncorrectDroppedComponent,
                      renderUndroppedMarkedComponent: props.renderUndroppedMarkedComponent
                    },
                    children: props.children
                  })
            });
}

var make = V3ClozeBucketProvider;

export {
  findByIdPairRightSide ,
  make ,
}
/* react Not a pure module */
